import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'exposure-plus-1', 'ExposurePlus1', [["path",{"d":"M3 12h6"}],["path",{"d":"M6 9v6"}],["path",{"d":"M18 19v-14l-4 4"}]]);